import EndpointsBase from "../EndpointsBase";

class HomeEndpoints extends EndpointsBase {
  getConveyorForWorkstation(workstationID: number) {
    return this._sendRequest({
      method: "getconveyorforworkstation",
      headers: this._getAuthHeader(null, workstationID),
      data: {},
      run: this.server.getData,
    });
  }

  getVersion(workstationID: number, isBeta: boolean) {
    return this._sendRequest({
      method: "getversion",
      headers: this._getAuthHeader(null, workstationID),
      data: { isBeta: isBeta },
      run: this.server.getData,
    });
  }
}

export default new HomeEndpoints();
